import React from "react"
import {Paper } from "material-ui"
import { IQuestion } from "../../../models"
import ImageLoader from "../../misc/ImageLoader"
import PunchQuestionAnswerViewer from "./PunchQuestionAnswerViewer"

interface IProps {
    imageS3Url: string
    questions: IQuestion[]
    btn1Ids: string[]
    btn2Ids: string[]
}

const PunchQuestionAnswerDetailContent: React.SFC<IProps> = (props: IProps) => {
    return (
        <div style={{ display: "flex" }}>
            <div style={{ flex: 1 }}>
                <PunchQuestionAnswerViewer
                    questions={props.questions}
                    btn1Ids={props.btn1Ids}
                    btn2Ids={props.btn2Ids}
                />
            </div>
            {props.imageS3Url &&
                <div style={{ marginLeft: 10 }}>
                    <Paper>
                        <ImageLoader
                            url={props.imageS3Url}
                            fixedHeight={250}
                        />
                    </Paper>
                </div>
            }
        </div>
    )
}

export default PunchQuestionAnswerDetailContent

